import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/time',
    name: 'time',
    component: () => import('../views/index-c-t.vue')
  },
  {
    path: '/sale',
    name: 'sale',
    component: () => import('../components/echart/right6/index.vue')
  },
]
const router = new VueRouter({
  routes
})

export default router